export enum VehicleMakeType {
    CAR = 'car',
    TRUCK = 'truck',
    WORK_MACHINE = 'work-machine',
    BICYCLE = 'bicycle',
    TRAILER = 'trailer',
}
